<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="400px">
      <custom-modal
        @onSubmit="submit"
        title="Update Service Charge"
        @onClose="show = false"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="Amount"
                rules="required"
              >
                <v-text-field
                  hide-details="auto"
                  outlined
                  dense
                  rows="3"
                  :error-messages="errors"
                  v-model="serviceCharge.amount"
                  label="Service Charge"
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
export default {
  data: () => ({
    dialog: false
  }),

  name: "ServiceCharge",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    serviceCharge: {
      type: Object,
      default: {}
    }
  },
  components: { ValidationProvider, ValidationObserver },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.serviceCharge);
          this.visible = value;
        }
      }
    }
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.$emit("AddingserviceCharge", this.serviceCharge);
      }
    }
  },

  created() {}
};
</script>

<style>
.vue-treeselect__control {
  margin-top: 15px;
  border: 0 0 1 0;
  outline: none;
  border-width: 0 0 2px;
  outline-offset: 0;
}
</style>
